const TokenService = {
    getLocalRefreshToken: () => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        return user?.refresh;
    },

    getLocalAccessToken: () => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        return user?.access || user?.token || user?.authToken;
    },

    updateLocalAccessToken: (token: string) => {
        let user = JSON.parse(localStorage.getItem("user") || "{}");
        user.access = token;
        // Just in case other fields effectively act as access token in different contexts
        user.token = token;
        localStorage.setItem("user", JSON.stringify(user));
    },

    updateLocalRefreshToken: (token: string) => {
        let user = JSON.parse(localStorage.getItem("user") || "{}");
        user.refresh = token;
        localStorage.setItem("user", JSON.stringify(user));
    },

    getUser: () => {
        return JSON.parse(localStorage.getItem("user") || "{}");
    },

    setUser: (user: any) => {
        localStorage.setItem("user", JSON.stringify(user));
    },

    removeUser: () => {
        localStorage.removeItem("user");
        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("authToken");
    },
};

export default TokenService;
